import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { Provider } from "@devowl-wp/real-product-manager-wp-client";
import { ConfigLicensingConsumer } from "./consumer.js";
import { ConfigContent } from "../content.js";
const ConfigLicensing = observer(()=>{
    return /*#__PURE__*/ _jsx(ConfigContent, {
        maxWidth: 800,
        style: {
            margin: "auto"
        },
        children: /*#__PURE__*/ _jsx(Provider, {
            children: /*#__PURE__*/ _jsx(ConfigLicensingConsumer, {})
        })
    });
});
export { ConfigLicensing };
